<template>
  <div class="login-container">
    <div class="logo" />
    <div class="form">
      <div class="program-title">创业就业项目后台</div>
      <h1>登录</h1>
      <el-card shadow="never" class="login-card el-card">
        <!--登录表单-->
        <el-form ref="form" :model="loginForm" :rules="loginRules">
          <el-form-item prop="mobile">
            <el-input class="el-input" v-model="loginForm.mobile" placeholder="请输入手机号" />
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" show-password placeholder="请输入密码" />
          </el-form-item>
          <el-form-item>
            <el-button style="width:350px" type="primary" @click="loginFun">登录</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data(){
    return {
      loginForm:{
        mobile:"",
        password:"",
      },
      loginRules: {
        mobile: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '手机号格式不正确',
          trigger: 'blur'

        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      }
    }
  },
  mounted(){
    console.log("加载执行")
  },
  methods: {
    loginFun(){
      this.$refs.form.validate(async(isOK) => {
        if (isOK) {
          let that = this;
          let data = {
            mobile: this.loginForm.mobile,
            password: this.loginForm.password
          }
          this.$axios.post(api + "/login", data).then(response => {
            let res = response.data;
            if (res.code == 0) {
              //  存token
              let UserInfo = res.data;
              that.$store.commit("setUserInfo", UserInfo);
              sessionStorage.setItem(
                "userInfo",
                JSON.stringify(that.$store.state.userInfo)
              );
              that.$router.push("/");
            } else {
              that.$message.closeAll();
              that.$message({
                showClose: true,
                message: res.desc,
                type: 'error'
              });
            }
          })
        }
      })

    }
  }
}
</script>
<style >
*{
  margin: 0;
  padding: 0;
}
.login-container {
  display: flex;
  align-items: stretch;
  height: 100vh;
  /*border: 1px solid black;*/
}
.logo {
  flex: 3;
  /*background: rgba(38, 72, 176) url(../src/assets/login_back.png) no-repeat center / cover;*/
  border-top-right-radius: 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  background-image: url("../assets/login_back.png") ;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
}
.form {
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 176px;
  /*border: 1px solid black;*/
}
.el-card {
  border: none;
  padding: 0;
}
h1 {
  padding-left: 20px;
  font-size: 24px;
}
.el-input {
  width: 350px;
  height: 44px;
  /*.el-input__inner {*/
  /*  background: #f4f5fb;*/
  /*}*/
}
/*.el-checkbox {*/
/*  color:#606266;*/
/*}*/
.program-title{
  font-size: 48px;
  font-weight: bolder;
  margin-bottom: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue